<template>
  <div>
      <div class="row d-flex justify-content-center" style="padding:5px" v-if="!loadingContent">
		<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-md-offset-4">
			<b-card>
				<div class="panel panel-default">
					<div class="panel-heading text-center">
						<img :src="cliente.logged.url_logo">
					<h3 class="panel-title">
						<b>
							<i class="fa fa-lock" aria-hidden="true"></i>
							Acesso Restrito
						</b>
					</h3>
					</div>
					<div class="panel-body">
						
						<ed-modal 
							title="Recuperar Senha"
							:modal="showModal" 
							width="50%"
							:onSave="recuperarSenha"
							:loadingSave="loadingRecuperarSenha"
							saveName="Recuperar Senha"

						>
							<div slot="modal-content">
								<ed-form :data="formData" :response="response" :itens="resetitens"/>
							</div>
						</ed-modal>

						<ed-form :data="formData" :response="response" :itens="loginItens">
							<div slot="form-footer" >
								<div class="col-md-12 btn-login">
									<ed-button 	
										icon="fa fa-sign-in"
										type="primary"
										@click="login"
										:loading="loadingSave"
										value="Entrar"
									/>
									<p style="padding-top:10px"><a href="#" @click="showModal = !showModal">Esqueci Minha Senha</a></p>
								</div>
							</div>
						</ed-form>
			
					</div>
				</div>
			</b-card>
		</div>
      </div>
  </div>
</template>

<script>

import Rest from "common/rest";
import EdModal from "common/modal";
import EdForm from "common/form";
import EdButton from "common/button";
import LoginItens from './_form/login'
import ResetItens from './_form/reset'

export default {
  components: {EdModal,EdForm,EdButton},
  mixins: [Rest],
  data() {
    return {
	  error: {},
	  response:{},
      formData: {
        cpf: null,
        cnpj: null,
		senha: null,
		point_type: 'empresa',
	  },
	  loginItens:[],
	  resetitens:[],
	  loadingSave: false,
	  loadingRecuperarSenha:false,
	  showModal: false,
	  loadingContent:true
    };
  },

  created() {

	if(this.logged())
		this.toRoute({name:'empresa.consulta'})
	else 
		this.loadingContent = false;
  },

  mounted(){
	this.loginItens = LoginItens;
	this.resetitens = ResetItens;
  },

  methods: {

    login() {

		this.loadingSave = true;
		this.error = {};
		this.response = {};

		this.post("login", this.formData).then(result => {
			result = result[0];

			this.loadingSave = false;
			this.response = result;

			if(result.status == 200) {

				var usuario = result.data.usuario, cliente = result.data.cliente;
				
				this.setCookie(this.env.jwt_empresa,result.data.jwt,usuario.sessao);
				
				this.usuario = usuario;
				this.cliente = cliente;

				this.toRoute({name:'empresa.consulta'});
			} 
		});
    },

    recuperarSenha() {
      	this.loadingRecuperarSenha = true;
		this.response = {};

		this.post("recuperar-senha", this.formData).then(result => {
			result = result[0];
			this.response = result;
			this.loadingRecuperarSenha = false;

			if(result.status == 200) {
				this.showModal = false;
				this.edAlert("Sua nova senha foi enviada para o email: " +result.data +". Aguarde alguns minutos e verifique sua caixa de entrada.");
			} 
		});
    }
  }
};
</script>

<style lang="scss">
.vertical-offset-100 {
  padding-top: 100px;
}
.btn-login{
	text-align: center;
	
}
.btn-login button{
	margin-top: 25px;
	width: 150px;
}
.panel-title{
	color:#666;
	font-size: 13pt;
}
</style>


// WEBPACK FOOTER //
// index.vue?b4f53b1a